import { MemberProfile } from '../data/member-profiles'

export function getMemberPhotoStyle(
  slug: string,
  context: 'profile' | 'card',
): React.CSSProperties {
  if (context === 'profile') {
    return {
      objectPosition: slug === 'jay' ? 'center 18%' : 'center top',
      transform:
        slug === 'jay'
          ? 'scale(1.8)'
          : slug === 'junior-ulloa'
            ? 'scale(1.5)'
            : undefined,
      transformOrigin: slug === 'junior-ulloa' ? 'center top' : undefined,
    }
  }

  // Card context (directory and marquee)
  return {
    objectPosition: slug === 'jay' ? 'center 20%' : 'center top',
    transform:
      slug === 'jay'
        ? 'scale(1.4)'
        : slug === 'junior-ulloa'
          ? 'scale(1.3)'
          : undefined,
    transformOrigin: slug === 'junior-ulloa' ? 'center top' : undefined,
  }
}

export function formatMemberLocation(city: string, state: string): string {
  if (!state || city.includes(state)) {
    return city
  }
  return `${city}, ${state}`
}

export function getTranslatedField<K extends keyof MemberProfile>(
  member: MemberProfile,
  field: K,
  isEs: boolean,
): string {
  const esField = `${String(field)}Es` as keyof MemberProfile
  if (isEs && member[esField]) {
    return member[esField] as string
  }
  return (member[field] as string) || ''
}

export function sanitizeSlug(raw: string): string {
  return raw.replace(/[^a-zA-Z0-9\-_]/g, '').slice(0, 100)
}